import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Thumbs } from "swiper/modules";

const ImageSlider = ({ images }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [mainImage, setMainImage] = useState(images?.[0]?.url); 
  const handleThumbnailClick = (url) => {
    setMainImage(url);
  };

  return (
    <div className="sm:p-4 w-full">
      <div className="mb-4">
        <img
          src={mainImage}
          alt="Main slider"
          className="w-full h-[400px] object-contain rounded-md"
        />
      </div>

      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={1}
        slidesPerView={4}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[Thumbs]}
        className="mySwiper1 mb-2"
      >
        {images?.map((item, index) => (
          <SwiperSlide key={index}>
            <img
              src={item.url}
              alt={`Thumbnail ${index + 1}`}
              className="h-[120px] object-contain rounded-md border cursor-pointer"
              onClick={() => handleThumbnailClick(item.url)}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ImageSlider;
